export default __webpack_public_path__ + "static/media/default-pic.921dff75.png";